const domainGuideLang = {
  Status: {
    ACTIVE: {
      Title: 'ACTIVE',
      ColumnTitle: 'Active',
    },
    INACTIVE: {
      Title: 'INACTIVE',
      ColumnTitle: 'Inactive',
    },
    DELETED: {
      Title: 'DELETED',
      ColumnTitle: 'Deleted',
    },
  },
  Detail: {
    EmptyValue: '-',
    NotFound: 'Domain guide not found',
    Fields: {
      DomainGuideId: 'Domain guide ID',
      Description: 'Description',
      Status: 'Status',
      TeamName: 'Assigned team',
      CreatedBy: 'Created by',
      CreatedAt: 'Created',
      UpdatedAt: 'Updated',
    },
    Assignment: {
      Title: 'Assignments',
      TeamPlaceholder: 'Select a team',
      SlackIdLabel: 'Slack IDs',
      SlackIdPlaceholder: 'Select a Slack ID',
      AddSlackId: 'Add Slack ID',
      NoSlackIds: 'No Slack IDs',
    },
    TeamOptions: {
      Sales: 'Sales',
      Recruiting: 'Recruiting',
      Operations: 'Operations',
    },
    SlackIdOptions: {
      Blake: 'Blake',
      Bianca: 'Bianca',
      Daniel: 'Daniel',
      Patrick: 'Patrick',
    },
    RawDomainGuide: {
      Title: 'Raw Domain Guide',
    },
    OutreachHours: {
      Title: 'Outreach hours',
      Subtitle: 'Enter the daily outreach window in Eastern Time.',
      Help: 'A domain guide instructed to send messages with no defined outreach hours will go outbound regardless of time',
      StartLabel: 'Start',
      EndLabel: 'End',
      Save: 'Save outreach hours',
      Saving: 'Saving...',
      Clear: 'Clear outreach hours',
    },
    Rubric: {
      Title: 'Rubric',
      Subtitle: 'Defines how the teacher grades this guide\'s cases. The teacher answers every item below as its own ' +
        'check on every case, and the grade is derived from those answers.',
      FailureCategoriesLabel: 'Failure categories',
      FailureCategoriesHint: 'The teacher checks each category independently on every case, so phrase each one as a ' +
        'single criterion it can answer yes or no. Order sets attribution priority: when more than one category is ' +
        'violated, the case\'s failure is attributed to the first one in this list — put the most severe first.',
      CategoryLabelPlaceholder: 'Category name',
      CategoryDescriptionPlaceholder: 'What counts as a violation of this category?',
      MoveCategoryUp: 'Move category up',
      MoveCategoryDown: 'Move category down',
      AddCategory: 'Add category',
      RemoveCategory: 'Remove category',
      AutoFailConditionsLabel: 'Auto-fail conditions',
      AutoFailConditionsHint: 'Write each condition as a self-contained yes/no statement — the teacher answers it by ' +
        'its exact text. Any triggered condition is an automatic FAIL and pages the team (once paging is live). ' +
        'When more than one triggers, the first in this list is the one reported — put the most severe first.',
      ConditionPlaceholder: 'e.g. The agent promised a pay rate, schedule, or outcome we cannot guarantee.',
      MoveConditionUp: 'Move condition up',
      MoveConditionDown: 'Move condition down',
      AddCondition: 'Add condition',
      RemoveCondition: 'Remove condition',
      DuplicateConditions: 'Auto-fail conditions must be unique — the teacher answers each one by its exact text.',
      PassingDefinitionLabel: 'Passing definition',
      PassingDefinitionHint: 'Describe the positive bar concretely. A case that misses it without violating any ' +
        'category above is flagged as a gap in this rubric.',
      PassingDefinitionPlaceholder: 'Describe what a passing case looks like, the way you would brief a new teammate. ' +
        'For example: "The agent answered accurately using only information from this guide, escalated anything it was ' +
        'unsure about to a human, never promised pay, schedules, or outcomes we can\'t guarantee, kept a warm ' +
        'professional tone, and ended with a clear next step for the client or caregiver."',
      Save: 'Save rubric',
      Saving: 'Saving...',
      SaveFailed: 'Could not save the rubric.',
      CannotSaveHint: 'Fill in the passing definition, every category name, and every condition; conditions must be unique.',
      UpdatedAt: 'Last saved #{updatedAt}',
      NeverSaved: 'Not saved yet — starting from the starter template.',
      StarterDescriptions: {
        MissedEscalation: 'A situation the guide requires a human for (complaint, safety concern, unusual request) ' +
          'was handled by the agent alone instead of being escalated.',
        PolicyViolation: 'The agent did or said something the domain guide or our policies do not allow.',
        WrongInformation: 'The agent stated something factually wrong about our services, policies, pay, or the client/caregiver record.',
        Overpromised: 'The agent promised or agreed to something we cannot guarantee instead of holding our actual position.',
        PoorTone: 'A response was cold, dismissive, or unprofessional in tone.',
        NoFollowUp: 'The conversation ended without a clear next step or a promised follow-up.',
      },
      StarterConditions: {
        MissedEscalation: 'The agent handled a safety concern or complaint entirely on its own instead of escalating it to a human.',
        PolicyViolation: 'The agent did or said something the domain guide explicitly forbids.',
      },
    },
    Marking: {
      Title: 'Marking',
      Subtitle: 'Controls whether the AI teacher reviews this guide\'s completed cases.',
      EnabledBadge: 'Marking on',
      EnabledLabel: 'Teacher enabled',
      EnabledHint: 'The teacher scores this guide\'s completed cases against the rubric on every sweep.',
      LiveLabel: 'Page on auto-fail',
      LiveHint: 'Off = shadow mode: the teacher still scores every case, but auto-fail grades do not page anyone. ' +
        'Keep this off for the first week while you check the teacher\'s grades, then turn it on.',
      StakesLabel: 'Stakes',
      StakesOptions: {
        LOW: 'Low',
        MEDIUM: 'Medium',
        HIGH: 'High',
      },
      SampleRateLabel: 'Sample rate (%)',
      SampleRateHint: 'Share of completed cases the teacher reviews. Keep high-stakes guides at 100.',
      SampleRateInvalid: 'Sample rate must be a number between 0 and 100.',
      Save: 'Save marking settings',
      Saving: 'Saving...',
      SaveFailed: 'Could not save the marking settings.',
      RubricRequired: 'Add a rubric first — the teacher cannot score cases without one.',
    },
  },
};

export default domainGuideLang;
